export default `
<script
  src="https://js.sentry-cdn.com/98eefed2636036c3bdb8377b11ff28fe.min.js"
  crossorigin="anonymous"
></script>
`;
